import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HxAuthService, HxCategoryService, HxRecipeService, HxUiLabelPipe, WorkflowCategoryModel, WorkflowModel } from 'hx-services';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Select current workflow
 */
@Component({
  selector: 'app-workflow-select',
  templateUrl: './workflow-select.component.html',
  styleUrls: ['./workflow-select.component.css'],
  imports: [NgIf, NgFor, NgClass, TranslocoPipe, HxUiLabelPipe]
})
export class WorkflowSelectComponent implements OnInit {
  @Input() brandId!: number;
  @Input() workflowId?: number;
  @Output() workflowChange = new EventEmitter<WorkflowModel | undefined>();

  workflows: WorkflowModel[] = [];
  isLoading = false;
  workflowCategories: WorkflowCategoryModel[] = [];
  workflowCategoryId?: number;

  constructor(
    private categoryService: HxCategoryService,
    private recipeService: HxRecipeService,
    private auth: HxAuthService,
  ) {
  }

  ngOnInit() {
    this.loadWorkflowCategoryList();
  }

  private async loadWorkflowCategoryList() {
    const result = await this.categoryService.getWorkflowCategories({brandId: this.brandId});
    if (result && result.list && result.list.length > 0) {
      for (let index = 0; index < result.list.length; index++) {
        this.workflowCategories.push(result.list[index]);
      }
      this.workflowCategoryId = result.list[0].id;
      this.loadList();
    }
  }

  private async loadList() {
    this.isLoading = true;
    this.workflows = [];
    try {
      const result = await this.recipeService.getWorkflowList({workflowCategoryId: this.workflowCategoryId, limit: 1000});
      this.workflows = result.list;
      if (this.workflowId) {
        const item = this.workflows.find(el => el.id === this.workflowId);
        this.selectWorkflow(item);
      }
    } finally {
      this.isLoading = false;
    }
  }

  selectWorkflow(item: WorkflowModel) {
    this.workflowChange.emit(item);
  }

  selectTag(model: WorkflowCategoryModel) {
    this.workflowCategoryId = model.id;
    this.loadList();
  }
}
